import { OnInit, OnDestroy, Component, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from '../../../infrastructure/iFilter-component';
import { MatDialog } from '@angular/material';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { Router } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { StudyReportSearchItem } from '../../../model/study-report-search-item';
import { StudyReportWizardService } from '../../../services/wizard/study-report/study-report.wizard.service';
import { AuthService } from '../../../services/auth.service';
// tslint:disable-next-line:max-line-length
import { StudyReportReverserReasonDialogComponent } from '../../dialogs/study-report-reverser-reason/study-report-reverser-reason-dialog.component';
import { StudyReportStateEnum } from '../../../model/study-report-state';
import { StudyReportCircuitEnum } from '../../../model/study-report-circuit';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { StudyReportWizardFactory } from '../../../factory/study-report-wizard.factory';
import { StudyReportService } from '../../../services/study-report/study-report.service';
import { StudyReportUnificationDialogService } from '../../../services/study-report/study-report-unification-dialog.service';
import { StudyReportUnificationService } from '../../../services/study-report/study-report-unification.service';
import { StudyReportViewerDialogRequest, StudyReportViewerDialogComponent } from '../../dialogs/study-report-viewer/study-report-viewer-dialog.component';
import { PdfService } from '../../../services/pdf.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'study-report-search-component',
  templateUrl: './study-report-search.component.html',
  styleUrls: ['./study-report-search.component.css']
})
export class StudyReportSearchComponent implements OnInit, OnDestroy {
  loading: boolean;
  loadingAction: boolean;
  studyReportSearchItem: StudyReportSearchItem[] = [];
  searchFilters: SearchFilter[];

  columnsDefinition = [
    { field: 'ReservationHour', title: 'Fecha del turno' },
    { field: 'DeliveryHour', title: 'Fecha entrega' },
    { field: 'Protocol', title: 'Protocolo' },
    { field: 'PatientFullName', title: 'Paciente' },
    { field: 'PracticeName', title: 'Práctica' },
    { field: 'ServiceName', title: 'Servicio' },
    { field: 'EntityName', title: 'Entidad' },
    { field: 'State', title: 'Estado' },
    { field: 'IsInternation', title: 'Internado' },
    { field: 'StudyReportRegion', title: 'Subesp.' },
    { field: 'AdminControled', title: 'Control admin.' },
    { field: 'LastLogisticscommentary', title: 'Comentarios log.' }
  ];
  _columnOrder: string[] = [];
  hiddenColumns: string[] = [];
  columnFilters: { [field: string]: string } = {};
  sortField = '';
  sortAsc = true;
  _draggingField = '';
  columnWidths: { [field: string]: number } = {};
  _filteredData: StudyReportSearchItem[] = [];
  dataSource: StudyReportSearchItem[] = [];
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(public dialog: MatDialog, private router: Router,
    private studyReportWizardService: StudyReportWizardService, private menuService: MenuService,
    private authService: AuthService, private studyReportService: StudyReportService,
    private confirmDialogService: ConfirmDialogService,
    private studyReportUnificationService: StudyReportUnificationService,
    private studyReportUnificationDialogService: StudyReportUnificationDialogService,
    private studyReportWizardFactory: StudyReportWizardFactory,
    private pdfService: PdfService,
    private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Servicio', 'Informar');
  }

  get orderedColumnsDefinition() {
    const defaultOrder = this.columnsDefinition.map(c => c.field);
    const baseOrder = this._columnOrder.length ? this._columnOrder : defaultOrder;
    const order = baseOrder.concat(defaultOrder.filter(f => baseOrder.indexOf(f) === -1));
    return order
      .filter(f => this.hiddenColumns.indexOf(f) === -1)
      .map(f => this.columnsDefinition.find(c => c.field === f))
      .filter(c => c != null);
  }

  get availableColumns() {
    return this.columnsDefinition;
  }

  get exportColumns(): string[] {
    return this.orderedColumnsDefinition.map(c => c.field);
  }

  get exportColumnsName(): string[] {
    return this.orderedColumnsDefinition.map(c => c.title);
  }

  ngOnInit(): void {
    this.loadColumnState();
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = pagedItems;
    this.loading = false;
  }


  onEndSearch(response: IFilterResponse<StudyReportSearchItem>) {
    this.studyReportSearchItem = response.items;
    this.searchFilters = response.searchFilters;
    this._filteredData = response.items;
    this.applyColumnFilters();
  }

  onStartSearch() {
    this.loading = true;
  }

  async studyReportEdit(studyReportSearchItem: StudyReportSearchItem) {
    try {
      if (!this.canReverse(studyReportSearchItem)) {
        studyReportSearchItem.Loading = true;
        await this.StudyReportLockAndStartWizard(studyReportSearchItem);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Informe');
    } finally {
      studyReportSearchItem.Loading = false;
    }
  }

  private async StudyReportLockAndStartWizard(studyReportSearchItem: StudyReportSearchItem) {
    const lockInfo = await this.studyReportService.studyReportLock(studyReportSearchItem.StudyReportId, studyReportSearchItem.PracticeRegionId, +this.authService.getStudyReportCircuitId(), this.authService.getUserId());
    if (!lockInfo.IsLock) {
      this.StudyReportWizardServiceInitialize(studyReportSearchItem);
    } else if (lockInfo.AutoLock) {
      this.confirmDialogService.confirm('Informe bloqueado', 'El informe está siendo editado actualmente por usted en esta u otra computadora. Desea continuar?', 'Sí', 'No').subscribe(async (value) => {
        if (value) {
          await this.studyReportService.studyReportUnlock(studyReportSearchItem.StudyReportId);
          this.studyReportEdit(studyReportSearchItem);
        }
      });
    } else {
      this.notificationToastService.error('El informe se encuentra bloqueado por el usuario '
        + lockInfo.UserLock, 'Informe bloqueado');
    }
  }

  private async StudyReportWizardServiceInitialize(studyReportSearchItem: StudyReportSearchItem) {
    // TODO: aca validar unificacion
    const info = await this.studyReportUnificationDialogService
      .startUnificationDialogIfRequired(studyReportSearchItem);
    if ( info ) {
      this.wizardServiceInitializeAndNavigate(info);
    }
  }

  private wizardServiceInitializeAndNavigate(studyReportSearchItem: StudyReportSearchItem) {
    this.studyReportWizardService.initialize(this.studyReportWizardFactory
      .CreateStudyReportWizard(studyReportSearchItem, false));
    this.router.navigate(['/study-report-wizard']);
  }

  studyReportView(studyReportSearchItem: StudyReportSearchItem): void {
    this.studyReportWizardService.initialize(
      this.studyReportWizardFactory.CreateStudyReportWizard(studyReportSearchItem, true));
    this.router.navigate(['/study-report-wizard']);
  }

  studyReportReverse(studyReportSearchItem: StudyReportSearchItem): void {

    if (studyReportSearchItem.IsInDelivery) {
      this.notificationToastService.error('No es posible revertir el informe', 'Informe');
    } else {
      const dialogRef = this.dialog.open(StudyReportReverserReasonDialogComponent, {
        width: '50%',
        data: studyReportSearchItem.StudyReportId
      });

      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.searchFilter.search();
        }
      });
    }
  }

  async controlAdmin(studyReportSearchItem: StudyReportSearchItem) {

    try {
      studyReportSearchItem.Loading = true;
      await this.studyReportService.adminControled( [studyReportSearchItem ]);
      studyReportSearchItem.AdminControled = 'Sí';
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Controlar admin.');
    } finally {
      studyReportSearchItem.Loading = false;
    }
}

  async undoControlAdmin(studyReportSearchItem: StudyReportSearchItem) {

        try {
          studyReportSearchItem.Loading = true;
          await this.studyReportService.rollbackAdminControled( [studyReportSearchItem ]);
          studyReportSearchItem.AdminControled = 'No';
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err.error), 'Revertir control admin.');
        } finally {
          studyReportSearchItem.Loading = false;
        }
  }

  async unlockCircuit(studyReportSearchItem: StudyReportSearchItem) {
    this.confirmDialogService.confirm('Desbloqueo informe', 'Esta seguro que desea desbloquear el informe?')
      .subscribe(async (result) => {
        try {
          if (result) {
            studyReportSearchItem = await this.studyReportService.studyReportUnlockCircuit(studyReportSearchItem);
            this._filteredData = this.studyReportSearchItem;
            this.applyColumnFilters();
          }
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err.error), 'Desbloqueo informe');
        }
      });
  }

  async undoStudyReportUnification(studyReportSearchItem: StudyReportSearchItem) {

    await this.studyReportUnificationService
      .undoStudyReportUnification(studyReportSearchItem.StudyReportId);
    this.searchFilter.search();
  }

  canReverse(studyReportSearchItem: StudyReportSearchItem): boolean {
    return <StudyReportStateEnum>studyReportSearchItem.StateId !== StudyReportStateEnum.Pending;
  }

  canUndoUnification(studyReportSearchItem: StudyReportSearchItem): boolean {

    return studyReportSearchItem.IsPrincipal ||
      studyReportSearchItem.StudyReportParentId !== null;
  }

  canUnlockCircuit(studyReportSearchItem: StudyReportSearchItem): boolean {
    if (studyReportSearchItem.StudyReportCircuitId) {
      const res = <StudyReportCircuitEnum>studyReportSearchItem.StudyReportCircuitId
      !== StudyReportCircuitEnum.DirectTypingWeb;
      return res && <StudyReportStateEnum>studyReportSearchItem.StateId === StudyReportStateEnum.Pending;
    } else {
      return false;
    }
  }

  async viewMergedStudyReport( studyReportSearchItem: StudyReportSearchItem ) {

    try {

      const studyReportViewerDialogRequest = new StudyReportViewerDialogRequest();
      studyReportViewerDialogRequest.CanConfirm = false;

      const report = await this.studyReportService
        .getStudyReportPdf( studyReportSearchItem.StudyReportId, true );

      if (report && report.ReportBase64) {
        const pdfUrl = this.pdfService.base64ToPdfUrl(report.ReportBase64);
        studyReportViewerDialogRequest.SafeResourceUrl =
            this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
        this.dialog.open(StudyReportViewerDialogComponent, {
          width: '90%',
          height: '600px',
          data: studyReportViewerDialogRequest
        });
      } else {
        this.notificationToastService.error('No existe informe confirmado para visualizar', 'Informes');
      }

    } catch (err) {
      console.log('***************');
      console.log(err);
      console.log('***************');
      this.notificationToastService.error(JSON.stringify(err.error), 'Informe');
    } finally {
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    if ((window as any).__studyReportSearchResizeMove) {
      window.removeEventListener('mousemove', (window as any).__studyReportSearchResizeMove);
    }
    if ((window as any).__studyReportSearchResizeUp) {
      window.removeEventListener('mouseup', (window as any).__studyReportSearchResizeUp);
    }
  }

  formatCellValue(element: StudyReportSearchItem, field: string): string {
    if (field === 'ReservationHour') {
      const d = element.DateTime;
      if (d == null) { return ''; }
      const date = d instanceof Date ? d : new Date(d);
      return date.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    if (field === 'DeliveryHour') {
      const d = element.DeliveryDate;
      if (d == null) { return ''; }
      const date = d instanceof Date ? d : new Date(d);
      return date.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    if (field === 'IsInternation') {
      return element.IsInternationYesOrEmpty != null ? String(element.IsInternationYesOrEmpty) : '';
    }
    const val = (element as any)[field];
    return val != null ? String(val) : '';
  }

  getSortableValue(element: StudyReportSearchItem, field: string): any {
    if (field === 'ReservationHour') {
      return element.DateTime ? new Date(element.DateTime).getTime() : 0;
    }
    if (field === 'DeliveryHour') {
      return element.DeliveryDate ? new Date(element.DeliveryDate).getTime() : 0;
    }
    const val = (element as any)[field];
    return val != null ? val : '';
  }

  applyColumnFilters(): void {
    const dataColumns = this.columnsDefinition.map(c => c.field);
    let filtered = this._filteredData.filter(element => {
      return dataColumns.every(field => {
        const filterVal = (this.columnFilters[field] || '').toLowerCase().trim();
        if (!filterVal) { return true; }
        const cellVal = this.formatCellValue(element, field).toLowerCase();
        return cellVal.indexOf(filterVal) !== -1;
      });
    });
    if (this.sortField) {
      const sf = this.sortField;
      const asc = this.sortAsc;
      filtered = filtered.slice().sort((a, b) => {
        const va = this.getSortableValue(a, sf);
        const vb = this.getSortableValue(b, sf);
        if (va < vb) { return asc ? -1 : 1; }
        if (va > vb) { return asc ? 1 : -1; }
        return 0;
      });
    }
    this.pager.setItems(filtered);
  }

  loadColumnState(): void {
    const savedOrder = sessionStorage.getItem('study-report-search.columns.v1');
    if (savedOrder) {
      try {
        const parsed = JSON.parse(savedOrder);
        if (Array.isArray(parsed)) {
          // Backward compatibility: legacy format saved only column order.
          this._columnOrder = parsed;
        } else {
          this._columnOrder = parsed.order || [];
          this.hiddenColumns = parsed.hidden || [];
        }
      } catch (e) {}
    }
    const savedSort = sessionStorage.getItem('study-report-search.sort');
    if (savedSort) {
      try {
        const s = JSON.parse(savedSort);
        this.sortField = s.field || '';
        this.sortAsc = s.asc !== false;
      } catch (e) {}
    }
    const savedWidths = sessionStorage.getItem('study-report-search.column-widths.v1');
    if (savedWidths) {
      try { this.columnWidths = JSON.parse(savedWidths); } catch (e) {}
    }
  }

  saveColumnOrder(): void {
    sessionStorage.setItem('study-report-search.columns.v1', JSON.stringify({
      order: this._columnOrder,
      hidden: this.hiddenColumns
    }));
  }

  saveSort(): void {
    sessionStorage.setItem('study-report-search.sort', JSON.stringify({ field: this.sortField, asc: this.sortAsc }));
  }

  saveColumnWidths(): void {
    sessionStorage.setItem('study-report-search.column-widths.v1', JSON.stringify(this.columnWidths));
  }

  isColumnVisible(field: string): boolean {
    return this.hiddenColumns.indexOf(field) === -1;
  }

  setColumnVisibility(field: string, visible: boolean): void {
    if (visible) {
      this.hiddenColumns = this.hiddenColumns.filter(f => f !== field);
    } else {
      if (this.hiddenColumns.indexOf(field) === -1) {
        this.hiddenColumns.push(field);
      }
    }
    this.saveColumnOrder();
  }

  showAllColumns(): void {
    this.hiddenColumns = [];
    this.saveColumnOrder();
  }

  getColumnWidth(field: string): number {
    return this.columnWidths[field] != null ? this.columnWidths[field] : 120;
  }

  sortByColumn(field: string): void {
    if (this.sortField === field) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortField = field;
      this.sortAsc = true;
    }
    this.saveSort();
    this.applyColumnFilters();
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) { return 'unfold_more'; }
    return this.sortAsc ? 'expand_less' : 'expand_more';
  }

  onColumnFilterInput(field: string, value: string): void {
    this.columnFilters[field] = value;
    this.applyColumnFilters();
  }

  onHeaderDragStart(event: DragEvent, field: string): void {
    this._draggingField = field;
    if (event.dataTransfer) { event.dataTransfer.effectAllowed = 'move'; }
  }

  onHeaderDragOver(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer) { event.dataTransfer.dropEffect = 'move'; }
  }

  onHeaderDrop(event: DragEvent, targetField: string): void {
    event.preventDefault();
    if (!this._draggingField || this._draggingField === targetField) { return; }
    const order = this._columnOrder.length
      ? this._columnOrder.slice()
      : this.columnsDefinition.map(c => c.field);
    const fromIndex = order.indexOf(this._draggingField);
    const toIndex = order.indexOf(targetField);
    if (fromIndex !== -1 && toIndex !== -1) {
      moveItemInArray(order, fromIndex, toIndex);
      this._columnOrder = order;
      this.saveColumnOrder();
    }
    this._draggingField = '';
  }

  onHeaderDragEnd(): void {
    this._draggingField = '';
  }

  startResize(event: MouseEvent, field: string): void {
    event.preventDefault();
    event.stopPropagation();
    const startX = event.clientX;
    const startWidth = this.getColumnWidth(field);
    const moveHandler = (e: MouseEvent) => {
      const newWidth = Math.max(40, startWidth + (e.clientX - startX));
      this.columnWidths[field] = newWidth;
    };
    const upHandler = () => {
      window.removeEventListener('mousemove', moveHandler);
      window.removeEventListener('mouseup', upHandler);
      (window as any).__studyReportSearchResizeMove = null;
      (window as any).__studyReportSearchResizeUp = null;
      this.saveColumnWidths();
    };
    (window as any).__studyReportSearchResizeMove = moveHandler;
    (window as any).__studyReportSearchResizeUp = upHandler;
    window.addEventListener('mousemove', moveHandler);
    window.addEventListener('mouseup', upHandler);
  }

}
